import type { RBACUser } from '../../../types';
import { userRegionDepartment } from '../copyRoles';

// One user's summary — an uppercase label over name / job title / region · department.
// Shared by the picker's "Assigning roles to" card (ReferenceUserPicker) and both the
// "from" and "to" ends of the review card (RoleCopyReview) so all three read identically.
export default function UserSummary({ label, user }: { label: string; user: RBACUser }) {
  const regionDepartment = userRegionDepartment(user);
  return (
    <div>
      <div className="text-xs uppercase tracking-wide opacity-60">{label}</div>
      <div className="font-semibold text-base">{user.displayName}</div>
      {user.jobTitle && <div className="text-sm opacity-80">{user.jobTitle}</div>}
      {regionDepartment && <div className="text-sm opacity-80">{regionDepartment}</div>}
    </div>
  );
}
